<template>
  <div id="app" class="flex h-100 flex-wrap pagebg" style="overflow: hidden">
    <div @click="back()" class="power">
      <i style="cursor: pointer; font-size: 0.6rem" class="el-icon-back"></i>
    </div>
    <div class="time">{{ now }} {{ week }}<br />
      <span>更新时间：{{ updateTimeText }}</span>
    </div>
    <div class="logoImg">
      <img style="height: 0.8rem" :src="logoSrc" />
    </div>
    <header class="w-100 h-10 flex j-center a-center">
      <!-- <h3 class="title">快速反应跟踪</h3> -->
      <!-- <el-button class="title" type="primary">{{ title }}</el-button> -->
      <div class="font-big font-weight light-title">
        {{ title ? title : "变化点看板" }}
      </div>
    </header>
    <div style="width:100%;padding:10px;">
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="card">
            <img width="42px" height="42px" src="../../assets/img/cpm/submit.png" />
            <span>已提交 <label>{{ dataTotal.confirm }}</label></span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="card">
            <img width="42px" height="42px" src="../../assets/img/cpm/approve.png" />
            <span>待批准 <label>{{ dataTotal.pending }}</label></span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="card">
            <img width="42px" height="42px" src="../../assets/img/cpm/finish.png" />
            <span>已完成 <label>{{ dataTotal.close }}</label></span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="card">
            <img width="42px" height="42px" src="../../assets/img/cpm/reject.png" />
            <span>已拒绝 <label>{{ dataTotal.refuse }}</label></span>
          </div>
        </el-col>
      </el-row>
    </div>
    <div style="text-align: center; margin-top: 20px;width:100%" v-if="dataList.length < 1">
      <h1 style="color: white; font-size: 20px">没有进行中的数据!</h1>
    </div>
    <div style="height:70vh; padding: 5px; width: 100%; overflow-x: scroll">
      <dv-scroll-board :config="actual" />
    </div>
  </div>
</template>

<script>
import API from "@/utils/api";
import { Loading } from "element-ui";
import router from "../../router";
import format from "date-fns/format";
export default {
  name: "response-board",
  data() {
    return {
      approveLoading: false,
      websock: null,
      updateTimeText: null,
      now: null,
      week: null,
      reconnectData: null,
      lockReconnect: false,
      logoSrc: "/assets/img/logo_light.png",
      title: "变化点看板",
      msg: "home",
      dataList: [],
      dataTotal: {
        confirm: 0,
        refuse: 0,
        pending: 0,
        close: 0
      },
      loading: null,
      issueDialog: false,
      issueData: {},
      colors: { Y: "#FFCC00", R: "#f44", G: "#06bf04" },
      todoTitle: { title: "", groupTitle: "" },
      screen: 1,
      pageSize: 16,
      too: 10000,
      actual: {},
    };
  },
  mounted() {
    //钟表
    setInterval(this.clock, 1000);
    this.loadBoardTitle();
    this.webSocket();
    this.init(); //保留http
  },
  destroyed() {
    if (this.websock) {
      this.lockReconnect = true;
      this.websock.close();
    }
  },
  filters: {},
  methods: {
    d8Process() {
      this.$router.push({
        path: "/fr/board",
        query: {
          key: this.$route.query.key,
        }
      });
    },
    oepnIssueDialog(item) {
      this.issueData = item;
      this.issueDialog = true;
    },
    loadBoardTitle() {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        return;
      } else {
        user = JSON.parse(user);
        sessionStorage.setItem("token", user.token);
        sessionStorage.setItem("http", user.http);
      }
      API.loadTheme().then((re) => {
        if (re.success && re["list"].length > 0) {
          this.logoSrc = re["list"][0]["icon"];
        }
      });
    },

    formatRate(data) {
      if (data.total > 0) {
        return parseInt(((data.completed / data.total) * 100).toFixed(0));
      } else {
        return 100;
      }
    },

    init() {
      this.actual = {
        startCharts: "",
        columnWidth: [100, 80, 100, 100, 100, 120, 480, 80, 80, 160],
        header: ["<span style='font-size: 0.28rem;'>日期</span>",
          "<span style='font-size: 0.28rem;'>班次</span>",
          "<span style='font-size: 0.28rem;'>零件号</span>",
          "<span style='font-size: 0.28rem;'>生产线</span>",
          "<span style='font-size: 0.28rem;'>变更类型</span>",
          "<span style='font-size: 0.28rem;'>工艺过程</span>",
          "<span style='font-size: 0.28rem;'>变化点内容</span>",
          "<span style='font-size: 0.28rem;'>确认人</span>",
          "<span style='font-size: 0.28rem;'>状态</span>",
          "<span style='font-size: 0.28rem;'>完成任务/总任务</span>",
        ],
        align: ["left", "left", "left", "center"],
        headerHeight: 65,
        headerBGC: "rgba(6, 30, 93, 0.5)",
        oddRowBGC: "rgba(0, 44, 81, 0.8)",
        evenRowBGC: "rgba(10, 29, 50, 0.8)",
        rowNum: 10,
        data: [],
      }
      this.loadTotal();
      this.loadData();
    },

    loadTotal() {
      var that = this;
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        return;
      } else {
        user = JSON.parse(user);
        sessionStorage.setItem("token", user.token);
        sessionStorage.setItem("http", user.http);
        API.cpmBoard()
          .then((res) => {
            if (res.success === true) {
              var value = res.value;
              that.dataTotal = value;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    loadData() {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        return;
      } else {
        this.startLoading();
        user = JSON.parse(user);
        sessionStorage.setItem("token", user.token);
        sessionStorage.setItem("http", user.http);

        const params = { "status": { "$in": [0, 1, 3] } };
        var queryParams = JSON.stringify(params);
        queryParams = encodeURIComponent(queryParams);

        API.cpmList(queryParams)
          .then((res) => {
            if (res.success === true) {
              this.formatData(res.list);
              var now = new Date();
              this.updateTimeText = format(now, "MM-dd HH:mm:ss");
            }
          })
          .catch((error) => {
            this.endLoading();
            console.log(error);
          });
      }
    },

    //格式化数据
    formatData(actualList) {
      this.endLoading();
      this.dataList = actualList;
      var actualData = [];
      for (var i = 0; i < actualList.length; i++) {
        var statusMap = { '0': '已提交', '1': '待批准', '2': '已完成', '3': '已拒绝' };
        var color = actualList[i]["status"] == 3 ? 'red' : 'white';
        var type = actualList[i]['optionTitle'].toString().split('/');;
        var line = actualList[i]["faStation"] ? actualList[i]["faStation"]['title'] : '';
        var user = actualList[i]["qa"] ? actualList[i]["qa"]['name'] : '';
        var date = '<span style="font-size: 0.24rem;">' + this.formatHour(actualList[i]['createdTime']) + "</span>";
        var product = '<span style="font-size: 0.24rem;">' + actualList[i]["productName"] + "</span>";
        var customer = '<span style="font-size: 0.24rem;">' + actualList[i]["partNumber"] + "</span>";
        var faStation = '<span style="font-size: 0.24rem;">' + line + "</span>";
        var rootTitle = '<span style="font-size: 0.24rem;">' + type[0] + "</span>";
        var optionTitle = '<span style="font-size: 0.24rem;">' + this.formtTitle(actualList[i]["optionTitle"]) + "</span>";
        var description = '<span style="font-size: 0.24rem;">' + actualList[i]["description"] + "</span>";
        var qa = '<span style="font-size: 0.24rem;">' + user + "</span>";
        var status = '<span style="font-size: 0.24rem;color:' + color + ';">' + statusMap[actualList[i]["status"]] + "</span>";
        var completedCount = '<span style="font-size: 0.24rem;">' + actualList[i]["completedCount"] + '/' + actualList[i]["todoCount"] + "</span>";
        var value = [date, product, customer, faStation, rootTitle, optionTitle, description, qa, status, completedCount];
        actualData.push(value);
      }

      this.actual = {
        startCharts: "",
        columnWidth: [150, 100, 150, 150, 150, 200, 650, 100, 100, 120],
        header: ["<span style='font-size: 0.28rem;'>日期</span>",
          "<span style='font-size: 0.28rem;'>班次</span>",
          "<span style='font-size: 0.28rem;'>零件号</span>",
          "<span style='font-size: 0.28rem;'>生产线</span>",
          "<span style='font-size: 0.28rem;'>变更类型</span>",
          "<span style='font-size: 0.28rem;'>工艺过程</span>",
          "<span style='font-size: 0.28rem;'>变化点内容</span>",
          "<span style='font-size: 0.28rem;'>确认人</span>",
          "<span style='font-size: 0.28rem;'>状态</span>",
          "<span style='font-size: 0.28rem;'>完成/总任务</span>",
        ],
        align: ["center", "center","center", "center","center", "center","center", "center","center","center"],
        headerHeight: 65,
        headerBGC: "rgba(6, 30, 93, 0.5)",
        oddRowBGC: "rgba(0, 44, 81, 0.8)",
        evenRowBGC: "rgba(10, 29, 50, 0.8)",
        rowNum: 10,
        data: actualData,
      }

    },
    formtTitle(val) {
      if (val) {
        var splitStr = val.split("/");
        if (splitStr.length > 0) {
          return splitStr[1];
        }
        return "";
      }
      return "";
    },
    webSocket() {
      var http = sessionStorage.getItem("http");
      var uuid = this.$route.query.key;
      if (http) {
        http += "/websocket/cpm/monitoring";
      } else {
        http = "https://demo.biqs.cn/websocket/cpm/monitoring";
      }

      http = http.replace("https", "wss").replace("http", "ws");

      this.websock = new WebSocket(http);
      this.websock.onopen = this.websocketonopen; //连接成功
      this.websock.onmessage = this.websocketonmessage; //广播成功
      this.websock.onerror = this.websocketonerror; //连接断开，失败
      this.websock.onclose = this.websocketclose;

      let this_ = this;

      //建议加上以下这一行代码，不加的效果图如下（当浏览器窗口缩小的时候）。超过了div的界限（红色边框）
      // window.addEventListener("resize", function() {
      //   myChart.resize();
      // });
    },
    //连接成功
    websocketonopen() {
      console.log("CPM socket 连接成功");
    },

    //连接失败
    websocketonerror() {
      console.log("CPM socket 连接失败");
      this.reconnect();
    },

    //各种问题导致的 连接关闭
    websocketclose() {
      console.log(" CPM socket 断开连接");
      this.reconnect();
    },
    //数据接收
    websocketonmessage(data) {
      //刷新
      this.init();
    },

    //断开重连
    reconnect() {
      if (this.lockReconnect) {
        return;
      }
      this.reconnectData && clearTimeout(this.reconnectData);
      this.reconnectData = setTimeout(() => {
        this.webSocket();
      }, 5000);
    },
    startLoading: function () {
      this.loading = Loading.service({
        lock: true,
        text: "加载中……",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    endLoading: function () {
      this.loading.close();
    },
    removeTAG(str) {
      if (str) {
        return str.replace(/<[^>]+>/g, "");
      } else {
        return str;
      }
    },
    formatDate(time) {
      if (time) {
        var date = new Date(Number(time));
        return format(date, "yyyy-MM-dd");
      }
      return "";
    },
    formatHour(time) {
      if (time) {
        var date = new Date(Number(time));
        return format(date, "yyyy/MM/dd");
      }
      return "";
    },
    back() {
      router.back();
    },
    clock() {
      //全局变量d，创建Date对象
      var d = new Date();
      //格式：2018-2-5  19:19:33
      this.now = format(d, "yyyy-MM-dd HH:mm:ss");
      var week = new Array(
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"
      )[d.getDay()];
      this.week = week;
    },
  },
};
</script>
<style>
.pagebg {
  background: url("../../assets/img/8dbg.png");
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src='./board.css'></style>



// WEBPACK FOOTER //
// src/pages/cpm/board.vue